import { z } from "zod";

export const longHeadSchema = z.object({
	number: z.number(),
	alias: z.string().optional(),
});

export type LongHead = z.infer<typeof longHeadSchema>;
